import { getHandler, patchHandler, deleteHandler, postHandler } from 'src/utils/fetchHandler';
import {
	getPendingNoteCreate,
	getPendingNoteDelete,
	getPendingNoteUpdate,
} from 'src/redux/notes/notes.selector';

export const NOTES_PATH = 'v2/notes';

export const CLEAR_NOTES = 'CLEAR_NOTES/NOTES/@WISELY/WEB';
export const CLEAR_NOTE_UPDATE_ERRORS = 'CLEAR_NOTE_UPDATE_ERRORS/NOTES/@WISELY/WEB';
export const CLEAR_NOTE_CREATE_ERRORS = 'CLEAR_NOTE_CREATE_ERRORS/NOTES/@WISELY/WEB';

export const clearNotes = () => ({
	type: CLEAR_NOTES,
});

export const clearNoteUpdateErrors = () => ({
	type: CLEAR_NOTE_UPDATE_ERRORS,
});

export const clearNoteCreateErrors = () => ({
	type: CLEAR_NOTE_CREATE_ERRORS,
});

/* Get notes */
export const GET_NOTES = 'GET_NOTES/NOTES/@WISELY/WEB';
export const FETCH_NOTES_FAILED = 'FETCH_NOTES_FAILED/NOTES/@WISELY/WEB';
export const FETCH_NOTES_SUCCEEDED = 'FETCH_NOTES_SUCCEEDED/NOTES/@WISELY/WEB';

export const getNotes = () => ({
	type: GET_NOTES,
});

export const fetchNotesFailed = payload => ({
	type: FETCH_NOTES_FAILED,
	payload,
});

export const fetchNotesSucceeded = payload => ({
	type: FETCH_NOTES_SUCCEEDED,
	payload,
});

export const fetchNotes = params => {
	return dispatch => {
		dispatch(getNotes());

		return getHandler(NOTES_PATH, params)
			.then(json => dispatch(fetchNotesSucceeded(json)))
			.catch(error => {
				console.error('fetchNotes error', error);
				dispatch(fetchNotesFailed(error));
			});
	};
};

/* Update note */
export const UPDATE_NOTE = 'UPDATE_NOTE/NOTES/@WISELY/WEB';
export const UPDATE_NOTE_SUCCEEDED = 'UPDATE_NOTE_SUCCEEDED/NOTES/@WISELY/WEB';
export const UPDATE_NOTE_FAILED = 'UPDATE_NOTE_FAILED/NOTES/@WISELY/WEB';

export const updateNote = () => ({
	type: UPDATE_NOTE,
});

export const requestUpdateNoteFailed = payload => ({
	type: UPDATE_NOTE_FAILED,
	payload,
});

export const requestUpdateNoteSucceeded = payload => ({
	type: UPDATE_NOTE_SUCCEEDED,
	payload,
});

export const requestUpdateNote = (id, body) => {
	return (dispatch, getState) => {
		if (getPendingNoteUpdate(getState())) {
			return;
		}

		dispatch(updateNote());
		const path = `${NOTES_PATH}/${id}`;

		return patchHandler(path, JSON.stringify(body))
			.then(json => dispatch(requestUpdateNoteSucceeded(json)))
			.catch(error => {
				console.error('requestUpdateNote error', error);
				dispatch(requestUpdateNoteFailed(error));
			});
	};
};

/* Delete note */
export const DELETE_NOTE = 'DELETE_NOTE/NOTES/@WISELY/WEB';
export const DELETE_NOTE_SUCCEEDED = 'DELETE_NOTE_SUCCEEDED/NOTES/@WISELY/WEB';
export const DELETE_NOTE_FAILED = 'DELETE_NOTE_FAILED/NOTES/@WISELY/WEB';

export const deleteNote = () => ({
	type: DELETE_NOTE,
});

export const requestDeleteNoteFailed = payload => ({
	type: DELETE_NOTE_FAILED,
	payload,
});

export const requestDeleteNoteSucceeded = payload => ({
	type: DELETE_NOTE_SUCCEEDED,
	payload,
});

export const requestDeleteNote = id => {
	return (dispatch, getState) => {
		if (getPendingNoteDelete(getState())) {
			return;
		}

		dispatch(deleteNote());
		const path = `${NOTES_PATH}/${id}`;

		return deleteHandler(path)
			.then(json => dispatch(requestDeleteNoteSucceeded(json)))
			.catch(error => {
				console.error('requestDeleteNote error', error);
				dispatch(requestDeleteNoteFailed(error));
			});
	};
};

/* Create note */
export const CREATE_NOTE = 'CREATE_NOTE/NOTES/@WISELY/WEB';
export const CREATE_NOTE_SUCCEEDED = 'CREATE_NOTE_SUCCEEDED/NOTES/@WISELY/WEB';
export const CREATE_NOTE_FAILED = 'CREATE_NOTE_FAILED/NOTES/@WISELY/WEB';

export const createNote = () => ({
	type: CREATE_NOTE,
});

export const requestCreateNoteFailed = payload => ({
	type: CREATE_NOTE_FAILED,
	payload,
});

export const requestCreateNoteSucceeded = payload => ({
	type: CREATE_NOTE_SUCCEEDED,
	payload,
});

export const requestCreateNote = body => {
	return (dispatch, getState) => {
		if (getPendingNoteCreate(getState())) {
			return;
		}

		dispatch(createNote());

		return postHandler(NOTES_PATH, JSON.stringify(body))
			.then(json => dispatch(requestCreateNoteSucceeded(json)))
			.catch(error => {
				console.error('requestCreateNote error', error);
				dispatch(requestCreateNoteFailed(error));
			});
	};
};



// WEBPACK FOOTER //
// ./src/redux/notes/notes.action.js